module.exports = __webpack_public_path__ + "static/media/eye.e010d9dd.svg";